export const AI_vs_Traditional_Devs_Data = {
    title: "Building Without AI Is Like Accounting Without Excel",
    subtitle: "AI doesn't replace developers — it empowers them. And we're fully powered.",
    cta: {
        text: "Build Smarter With AI",
        link: "/contact-us"
    },
    comparison: [
        {
            traditional: "Builds everything from scratch",
            ai_adopted: "Leverages AI to scaffold, debug & accelerate"
        },
        {
            traditional: "Spends hours fixing bugs manually",
            ai_adopted: "Gets smart suggestions & instant fixes"
        },
        {
            traditional: "Needs multiple tools to design, write, and test",
            ai_adopted: "Unified workflow with AI copilots"
        },
        {
            traditional: "Creativity limited by time & scope",
            ai_adopted: "Can explore 10x more creative solutions in minutes"
        },
        {
            traditional: "Slower iterations, longer timelines",
            ai_adopted: "Rapid prototypes, quicker pivots"
        },
        {
            traditional: "Relies solely on memory & docs",
            ai_adopted: "Has an AI memory and assistant 24/7"
        }
    ]
}; 